import { HeaderMenus as HeaderMenusKR } from './header';
import { FooterMenu as FooterMenuKR, FooterCopyRightLinks as FooterCopyRightLinksKR } from './footer';
import { GlobalNavigationConfig } from '../../../entities';

export const KoreaConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'korea',
  menu: {
    copyright: FooterCopyRightLinksKR,
    footer: FooterMenuKR,
    header: HeaderMenusKR,
  },
};
